import { useState, useEffect } from 'react';
import { getIsTouchDevice } from '@yme/utils/getIsTouchDevice';
const isTouchDevice = getIsTouchDevice();
const isSafari = 'standalone' in window.navigator;
const INTERNAL_STATE = {
    isTouchOnly: isTouchDevice, // by default, assume any touch device is touch only
};
const handleTouchOnly = (e) => {
    const hasZeroMovements = e.movementX === 0 && e.movementY === 0;
    if (hasZeroMovements) {
        return;
    }
    // after the first mousemove event, we know the device is not touch only
    INTERNAL_STATE.isTouchOnly = false;
    callbacks.forEach((callback) => callback());
};
if (isTouchDevice && !isSafari) {
    window.addEventListener('mousemove', handleTouchOnly, {
        once: true,
    });
}
const callbacks = [];
export const useTouchOnly = () => {
    const [isTouchOnly, setIsTouchOnly] = useState(INTERNAL_STATE.isTouchOnly);
    const callback = () => {
        setIsTouchOnly(false);
    };
    useEffect(() => {
        callbacks.push(callback);
        return () => {
            const index = callbacks.indexOf(callback);
            if (index > -1) {
                callbacks.splice(index, 1);
            }
        };
    }, []);
    if (!isTouchDevice) {
        return false;
    }
    return isTouchOnly;
};
